import WebsiteBehaviors from "../website-behaviors/index.js";

class Twitter extends WebsiteBehaviors {
	identifier() {
		return "Twitter";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "twitter.com");
	}

	styles() {
		// language=CSS
		return `
			body {
				overflow: initial;
			}
		`;
	}
}

export default Twitter;
